import { NgModule } from '@angular/core';
import { DataStorageService } from '../services/storage/custom/data-storage.service';
import { LocalStorageService } from '../services/storage/custom/local-storage.service';
import { BaseLoopBackStorageService } from '../services/storage/loopback/base.service';
import { AccountLoopBackApiService } from '../services/api/loopback/custom/account.service';
import { BaseLoopBackApiService } from '../services/api/loopback/base.service';
import { BaseErrorService } from '../services/error/base.service';
import { UploadLoopBackApiService } from '../services/api/loopback/custom/upload.service';
import { SettingLoopBackApiService } from '../services/api/loopback/custom/setting.service';

@NgModule({
  imports: [
  ],
  declarations: [
  ],
  exports: [
  ],
  providers: [
    DataStorageService,
    LocalStorageService,
    BaseLoopBackStorageService,
    BaseLoopBackApiService,
    BaseErrorService,
    AccountLoopBackApiService,
    UploadLoopBackApiService,
    SettingLoopBackApiService,
  ]
})
export class ServiceModule { }


// WEBPACK FOOTER //
// ./src/app/shared/service.module.ts